import { jsx as _jsx } from "react/jsx-runtime";
import trillionGreenUrl from '../../../assets/gems/trillion_green.svg?inline';
export function TrillionGreen({ ...props }) {
    return _jsx("img", { ...props, src: trillionGreenUrl, alt: 'TrillionGreenImage' });
}
